import { LONG_DASH } from 'constants'
import { useMemo, useState } from 'react'

import { getChainId, getTokenInfo } from 'constants/tokens'
import { formatUnits } from '@ethersproject/units'
import { WalletTransactionsCSS } from './WalletTransactionsCSS.styled'
import { useWalletTransactionData } from './useWalletTransactionData'
import { v4 as uuid } from 'uuid'
import { DateTime } from 'luxon'
import { currencyFormatter } from 'utils'
import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'

/*prettier-ignore*/
const DEPOSIT_HEADER = [
  {id:'0', caption:'Created', rowField: 'date' ,formatterId:'date' ,gridWidth:'1fr'},
  {id:'1', caption:'Status', rowField: 'status' ,formatterId:'' ,gridWidth:'1fr'},
  //{id:'2', caption:'Address', rowField: 'address', formatterId:''       ,gridWidth:'1fr'},
  {id:'3', caption:'Tx#', rowField: 'txHash' ,formatterId:'' ,gridWidth:'2fr'},
  {id:'4', caption:'Amount', rowField: 'amount' ,formatterId:'amount' ,gridWidth:'1fr'},
  {id:'5', caption:'Asset', rowField: 'asset' ,formatterId:'' ,gridWidth:'1fr'},
  {id:'6', caption:'Chain', rowField: 'chain' ,formatterId:'' ,gridWidth:'1fr'},
]

/*prettier-ignore*/
const WITHDRAW_HEADER = [
  {id:'0', caption:'Created', rowField:'createdAt' ,formatterId:'date' ,gridWidth:'1fr'},
  {id:'1', caption:'Satus', rowField:'status' ,formatterId:'' ,gridWidth:'1fr'},
  {id:'2', caption:'Address', rowField:'address' ,formatterId:'' ,gridWidth:'1fr'},
  {id:'3', caption:'Tx#', rowField:'transferTxHash' ,formatterId:'' ,gridWidth:'1fr'},
  {id:'4', caption:'Amount', rowField:'amount' ,formatterId:'amount' ,gridWidth:'1fr'},
  // {id:'5', caption:'Asset',   rowField:'' ,formatterId:'',            ,gridWidth:'1fr'},
  // {id:'6', caption:'Type',    rowField:'' ,formatterId:'',            ,gridWidth:'1fr'},
]

// '2023-03-23T23:56:49.027Z'
// '2023-03-23T23:56:46.809Z'

const headerSelector = (activeTab) =>
  ({
    deposit: DEPOSIT_HEADER,
    withdraw: WITHDRAW_HEADER,
  }[activeTab] || DEPOSIT_HEADER)

const gridColumnsSelector = (headers) => headers.reduce((array, item) => [...array, item.gridWidth], []).join(' ')

export const WalletTransactions = ({ activeTab }) => {
  const [sortKey, setSortKey] = useState('createdAt')

  const header = useMemo(() => headerSelector(activeTab), [activeTab])
  const gridColumns = useMemo(() => gridColumnsSelector(header), [header])
  const { data: rows, isPending } = useWalletTransactionData(activeTab)

  const formatters = useMemo(
    () => ({
      date: (txRow, field) => DateTime.fromISO(txRow[field]).toFormat('MM/dd/yyyy HH:mm:ss'),
      amount: (txRow, field) => {
        const chainId = getChainId(txRow.chain?.toUpperCase())
        const tokenInfo = getTokenInfo(txRow.asset || 'USDC', chainId)
        if (!tokenInfo) return LONG_DASH
        return currencyFormatter(formatUnits(txRow.amount, tokenInfo?.decimals), {noCurrencySign: true})
      },
    }),
    []
  )

  return (
    <WalletTransactionsCSS gridColumns={gridColumns}>
      <div className='tabbed_section deposit_history'>
        <div className='panel_title'>
          <ContentSwitcherByState
            activeState={activeTab}
            stateObject={{
              deposit: 'Deposit History',
              withdraw: 'Withdraw History',
            }}
          />
        </div>
        <div id='my-dashboard-grid'>
          <div className='main_cards full user_dashboard'>
            <form className='tabs_wrapper'>
              <div className='panels'>
                <div className='panel'>
                  <div className='card'>
                    <div className='grid_unclaimed_earnings'>
                      {/* {	<!-- TABLE HEAD -->} */}

                      {header.map((column) => (
                        <span key={column.caption} className='head'>
                          <strong>{column.caption}</strong>
                          <div className='triangle button white'>
                            <div className='triangle up white'></div>
                          </div>
                        </span>
                      ))}

                      {/* <!-- ROWS --> */}
                      {rows.map((row) =>
                        header.map((column) => (
                          <span key={uuid()} className='cell'>
                            {column.formatterId
                              ? formatters[column.formatterId](row, column.rowField)
                              : row[column.rowField]}
                          </span>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className='loading'>
          <SingleDataLoader loading={isPending} data={null} />
        </div>
      </div>
    </WalletTransactionsCSS>
  )
}
